import React from "react";
import { useLocation, useParams } from "react-router-dom";
import SelfComposeFlowHeader from "../selfCompose/SelfComposeFlowHeader";
import { useSearch } from "../../../../contexts/SearchContext";
import { useBookingFlow } from "../hooks/useBookingFlow";
import { isAgentFlightResultsListUrl } from "../../flightBookingPathUtils";
import { getFlightWizardStepMeta } from "./flightWizardConfig";
import FlightResultsModeToggle from "./FlightResultsModeToggle";

export default function FlightWizardStepHeader() {
  const { pathname } = useLocation();
  const { flightStep } = useParams();
  const { currentStep } = useBookingFlow();
  const { loading } = useSearch();
  const onResultsListUrl = isAgentFlightResultsListUrl(pathname, flightStep);
  const meta = getFlightWizardStepMeta(currentStep);
  const Icon = meta.Icon;

  if (currentStep === "selfComposePick") {
    return <SelfComposeFlowHeader />;
  }

  if (
    currentStep === "results" ||
    (currentStep === "search" && (onResultsListUrl || loading))
  ) {
    return <FlightResultsModeToggle />;
  }

  if (currentStep === "review") {
    return null;
  }

  if (currentStep === "flightDetails") {
    return null;
  }

  return (
    <header className="fw-step-header">
      <div className="fw-step-header__icon" aria-hidden>
        <Icon />
      </div>
      <div className="fw-step-header__copy">
        <h2 className="fw-step-header__title">{meta.title}</h2>
        <p className="fw-step-header__subtitle">{meta.subtitle}</p>
      </div>
    </header>
  );
}
